<div *ngIf="!isExpired" class="dsm-flex-container checkerboard {{textStyle}}"
     [ngStyle]="{'background-color': backgroundColor}">
    <div class="flex-row {{imageAlignment}}">
        <div class="flex-col image-wrapper">
            <violator *ngIf="hasViolator" [alignment]="imageAlignment" [textStyle]="violatorTextStyle"
                      [backgroundColor]="violatorBackgroundColor"
                      [translationRoot]="translationRoot" [useLocaleOverride]="useLocaleOverride"></violator>
            <img class="img-fluid" src="{{mobileImagePath}}" alt="">
        </div>
        <div class="flex-col col-text">
            <h2 class="heading-2">{{ translationRoot + '.title' | translate:useLocaleOverride }}</h2>
            <p>{{ translationRoot + '.body' | translate:useLocaleOverride }}</p>
            <countdown *ngIf="hasDuration" [countdownStartDate]="applicationStart" [duration]="componentData.durations[0]"></countdown>
            <button *ngIf="componentData.includeCallToAction" type="button" class="button button-large {{buttonType}}"
                    (click)="callToActionClick()">
                {{ translationRoot + '.button' | translate:useLocaleOverride }}
            </button>
        </div>
    </div>
</div>


